export const GenderOptionsEnum = {
    male: { label: 'Male', value: 'MALE' },
    female: { label: 'Female', value: 'FEMALE' },
    others: { label: 'Others', value: 'OTHER' },
  };

  